import type { UUID } from '@cmg/common';
import { Button } from '@cmg/design-system';
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useRoutes } from '../../../../common/hooks/useRoutes/useRoutes';
import { PageGridSection } from '../../../../design-system/body-sections/PageGridSection';
import { IdentityPageContent } from '../../../../design-system/IdentityPageContent';
import { InvestorFirmsGrid } from './components/InvestorFirmsGrid/InvestorFirmsGrid';

export function CRMInvestorFirmsRoute() {
  const navigate = useNavigate();

  const { crmIntegrationId } = useParams<{ crmIntegrationId?: UUID }>();

  const { crmInvestorFirmsNew } = useRoutes(crmIntegrationId);

  const handleAddInvestorFirm = useCallback(() => {
    navigate(crmInvestorFirmsNew.getUrlPath({ crmIntegrationId }));
  }, [navigate, crmInvestorFirmsNew, crmIntegrationId]);

  return (
    <IdentityPageContent
      slotProps={{ grid: { height: '100%' } }}
      gridContent={
        <PageGridSection
          slotProps={{ stack: { height: '100%' } }}
          size="large"
          title="Investor Firms"
          actions={[
            <Button
              key="add-investor-firm-button"
              variant="contained"
              onClick={handleAddInvestorFirm}
            >
              Add Investor Firm
            </Button>,
          ]}
          content={<InvestorFirmsGrid />}
        />
      }
    />
  );
}
